 <template>
    <div class="container flex pb-24 pl-6 pr-6 lg1024:pl-0 lg1024:pr-0">
        <div class="w-full lg1024:border-r lg1024:border-themeGray pt-8">
          <section v-if="newsMessage" class="breadcrumbsContainer py-2">
            <div class="breadcrumbs row_line">
              <a href="/">{{ mainPageMessage }}</a>
              <i class="mdi mdi-chevron-right"></i>
              <span>{{ newsMessage }}</span>
            </div>
          </section>
            <div class="font-bold text-2xl">{{getTitleMessage()}}</div>
            <div v-if="rendered">
              <template v-if="posts.length">
                <PostsGrid :layout="'columns'" :posts="posts"/>
                <div v-if="next" class="py-8 flex items-center justify-center">
                  <Loader v-if="loadNextPage"/>
                  <button v-else class="productButtonLink" @click="onNext">{{ nextPageMessage }}</button>
                </div>
              </template>
              <div class="flex justify-center relative mt-20" v-else>{{getErrorMessage()}}</div>
            </div>
            <div class="min-h-screen flex justify-center relative" v-else>
                <Loader />
            </div>
        </div>
        <SidebarWidget :position="'right'" v-if="rendered" class="hidden lg1024:flex">
        </SidebarWidget>
    </div>
</template>

<script>
import SidebarWidget from "../components/SidebarWidget.vue";
import PostsGrid from "../components/PostsGrid.vue";
import Loader from "../components/Loader.vue";
import NewList from "../mixins/NewList";
export default {
  name: 'NewPosts',
  components: {
    SidebarWidget,
    PostsGrid,
    Loader
  },
  mixins: [NewList],
  data() {
    return {
      posts: [],
      rendered: false,
    }
  },
  computed: {
    newsMessage() {
      return this.$store.getters.getTranslation("news");
    },
    mainPageMessage() {
      return this.$store.getters.getTranslation("main_page");
    }
  },
  methods: {
    getTitleMessage() {
      return this.$store.getters.getTranslation("most_actual");
    },
    getErrorMessage() {
      return this.$store.getters.getTranslation("no_posts");
    }
  },
  beforeMount() {
    this.$store.commit("changeCurrentUrl", "newPosts");
    this.listMounted()
    this.initEventScroll()
  },
  mounted () {
    const time = setInterval(() => {
      const title = this.$store.getters.getTitle
      const description = this.$store.getters.getDescription
      const header = this.$store.getters.getHeader

      if ('main' in title) {
        if ('main' in title && title.main !== 'none') {
          document.querySelector('title').innerText = title.main
          document.querySelector('meta[name="description"]').innerText = description.main
          this.$store.commit('updateHeaderFocus', header.main)
        } else {
          document.querySelector('title').innerText = 'Coral News'
          document.querySelector('meta[name="description"]').innerText = ''
          this.$store.commit('updateHeaderFocus', 'none')
        }

        clearInterval(time)
      }
    }, 240)
  }
}
</script>

<style scoped>

</style>
